import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-21v2',
  templateUrl: './21v2.component.html',
})
export class VbList21v2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
